import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const clientes = [
  {
    nombre: "CVeerkamp",
    anios: [
      { anio: 2025, acciones: [{ label: "Descargar Inventario", href: "xlsx/gestion-servicios-inventarios/Inventario-de-Bienes-Veerkamp.xlsx" }] },
      { anio: 2026, acciones: [{ label: "Ver Póliza", to: "/gestion-servicios-contratados/cveerkamp-2026" }] },
    ],
  },
  {
    nombre: "Eficasia",
    anios: [
      { anio: 2025, acciones: [
        { label: "Ver Póliza", to: "/gestion-servicios-contratados/eficasia-2025" },
        { label: "Descargar Inventario", href: "xlsx/gestion-servicios-inventarios/251211-Inventario-Eficasia.xlsx" },
      ] },
      { anio: 2026, acciones: [{ label: "Ver Póliza", to: "/gestion-servicios-contratados/eficasia-2026" }] },
    ],
  },
  {
    nombre: "Enestas",
    anios: [{ anio: 2025, acciones: [{ label: "Ver Póliza", to: "/gestion-servicios-contratados/enestas-2025" }] }],
  },
  {
    nombre: "La Comer",
    anios: [{ anio: 2025, acciones: [{ label: "Ver Póliza", to: "/gestion-servicios-contratados/la-comer-2025" }] }],
  },
  {
    nombre: "Havas",
    anios: [{ anio: 2026, acciones: [{ label: "Ver Póliza", to: "/gestion-servicios-contratados/havas-2026" }] }],
  },
  {
    nombre: "ICMyL",
    anios: [{ anio: 2025, acciones: [
      { label: "Ver Póliza", to: "/gestion-servicios-contratados/icmyl-2025" },
      { label: "Descargar Inventario", href: "xlsx/gestion-servicios-inventarios/260330-Invenatrio-Bienes.xlsx" },
    ] }],
  },
  {
    nombre: "ICACC",
    anios: [{ anio: 2025, acciones: [{ label: "Ver Póliza", to: "/gestion-servicios-contratados/icacc-2025" }] }],
  },
  {
    nombre: "Mgavilan",
    anios: [{ anio: 2025, acciones: [
      { label: "Ver Póliza de Switches", to: "/gestion-servicios-contratados/mgavilan-2025-sw" },
      { label: "Ver Póliza de Firewall", to: "/gestion-servicios-contratados/mgavilan-2025-fw" },
    ] }],
  },
  {
    nombre: "Herdez",
    anios: [{ anio: 2024, acciones: [
      { label: "Descargar Listado de Activos", href: "xlsx/gestion-servicios-inventarios/240216-Listado-de-activos-Herdez.xlsx" },
      { label: "Descargar Relación Apps", href: "xlsx/gestion-servicios-inventarios/240731-Relacion-APs-Herdez.xlsx" },
    ] }],
  },
  {
    nombre: "MCM Waas",
    anios: [{ anio: 2025, acciones: [
      { label: "Descargar Inventario", href: "xlsx/gestion-servicios-inventarios/251217-Inventario-Netjer-MCM.xlsx" },
      { label: "Descargar Clientes Vigentes", href: "xlsx/gestion-servicios-inventarios/251217-MCM-Clientes-Vigentes.xlsx" },
    ] }],
  },
  {
    nombre: "IKE",
    anios: [{ anio: 2026, acciones: [{ label: "Ver Póliza", to: "/gestion-servicios-contratados/ike-2026" }] }],
  },
  {
    nombre: "UCI",
    anios: [{ anio: 2025, acciones: [{ label: "Descargar Inventario", href: "xlsx/gestion-servicios-inventarios/260330-Inventario-de-Equipos-UCI.xlsx" }] }],
  },
  {
    nombre: "K-Networking",
    anios: [{ anio: 2026, acciones: [{ label: "Ver Póliza", to: "/gestion-servicios-contratados/k-Networking-2026" }] }],
  },
  {
    nombre: "UAM Xochimilco",
    anios: [{ anio: 2026, acciones: [
      { label: "Ver Póliza", to: "/gestion-servicios-contratados/uam-xochimilco-2026" },
      { label: "Descargar Inventario", href: "xlsx/gestion-servicios-inventarios/Seriales-X5320-Xochimilco.xlsx" },
    ] }],
  },
  {
    nombre: "INNES AIRES",
    anios: [{ anio: 2026, acciones: [{ label: "Ver Póliza", to: "/gestion-servicios-contratados/innes-aires-2026" }] }],
  },
];

const GestionServiciosContratados = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Gestión de Servicios Contratados</h1>
        </div>
        <div className="orgproc-grid-4col">
          {clientes.map((cliente, index) => (
            <div className="orgproc-card" key={cliente.nombre}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Cliente #{index + 1}</div>
                <div className="orgproc-card-title">{cliente.nombre}</div>
                {cliente.anios.map((bloqueAnio) => (
                  <div className="orgproc-year-row" key={bloqueAnio.anio}>
                    <span className="orgproc-year-badge">{bloqueAnio.anio}</span>
                    <div className="orgproc-card-actions orgproc-card-actions--inline">
                      {bloqueAnio.acciones.map((accion) =>
                        accion.href ? (
                          <a
                            className="orgproc-card-btn"
                            href={`${bucketUrl}/${accion.href}`}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                            key={accion.href}
                          >
                            {accion.label} →
                          </a>
                        ) : (
                          <Link className="orgproc-card-btn" to={accion.to} key={accion.to}>
                            {accion.label} →
                          </Link>
                        )
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default GestionServiciosContratados;